import Vue from 'vue'
import Vuex from 'vuex'

import AjaxGetData from './modules/ajax-get-data'
import TestDocument from './modules/testDocument'
import CompanyNews from './modules/companyNews'
import Log from './modules/log'
import Faq from './modules/faq'
import Paper from './modules/paper'
import Utility from './modules/utility'
import Module from './modules/module'
import TestLog from './modules/testLog'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		AjaxGetData,
    TestDocument,
    CompanyNews,
    Log,
    Faq,
    Paper,
    Utility,
    Module,
    TestLog
	}
})
